/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "moment";

/* Helpers, constants, custom methods, internal libraries */
import { useReportsService  } from "../../../../services/reportsService";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../../../constants/appConstants";

/* Components */
import TicketsFilters from "./ticketsFilters";
import TicketsGrid from './ticketsGrid';

/* Styles */
import styles from "./styles.js"


const TicketTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();
  const { initAnalytics } = useAnalytics();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/tickets')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      page: +initialPage,
      bookingStartDate: moment().startOf('year').format('YYYY-MM-DD'),
      bookingEndDate: moment().format('YYYY-MM-DD'),
      travelStartDate: '',
      travelEndDate: '',
    };
  });

  const { ticketsResponse, getTicketsList } = useReportsService();

  const enableDownloadButton = ticketsResponse?.results?.dataItems.length > 0;

  useEffect(() => {
    getTicketsList(gridOptions);
    gridOptions.page > 1 ? navigate(`/app/reports/tickets?page=${gridOptions.page}`) : navigate(`/app/reports/tickets`)
  }, [gridOptions]);

  const onRowClick = row => {}

  const handleSort = (column, sortDirection) => {
    setGridOptions({
      ...gridOptions,
      sortby: column.id,
      sortdirection: sortDirection === "desc" ? "dsc" : sortDirection,
    });
  };

  return (
    <div className={classes.ticketsTab}>
      <TicketsFilters
        response={ticketsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        type="REPORTS"
        enableDownloadButton={enableDownloadButton}
      />
      <TicketsGrid
        ticketsResponse={ticketsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        onRowClick={onRowClick}
        handleSort={handleSort}
        defaultSort={ticketsResponse?.defaultSort}
      />
    </div>
  )
}

export default TicketTab;
